import type { MouseEvent } from "react";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

interface ImagePreviewProps {
  imageUrl: string;
  handleChangeCoverClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  handleDelete?: (event: MouseEvent<HTMLButtonElement>) => void;
}
export const ImagePreview = ({
  imageUrl,
  handleChangeCoverClick,
  handleDelete,
}: ImagePreviewProps) => (
  <div className="bg-secondary group relative aspect-[1279/680] w-full rounded-lg">
    <img
      src={imageUrl}
      loading="lazy"
      alt={t("courses.edit.lesson.cover_media_alt")}
      className="h-full w-full rounded-lg"
    />
    <div className="invisible absolute bottom-1/2 right-1/2 flex translate-x-1/2 translate-y-1/2 gap-4 group-hover:visible">
      <Button
        variant="secondary"
        type="button"
        onClick={handleChangeCoverClick}
      >
        {t("change")}
      </Button>
      <Button variant="secondary" type="button" onClick={handleDelete}>
        {t("delete")}
      </Button>
    </div>
  </div>
);
